import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import { createSelector, createSelectorMemoized } from '@base-ui/utils/store';
import { schedulerPreferenceSelectors } from '@mui/x-scheduler-internals/scheduler-selectors';
import { EVENT_TIMELINE_PREMIUM_PRESET_CONFIGS } from "../internals/utils/preset-utils.mjs";
export const eventTimelinePremiumPresetSelectors = {
  preset: createSelector(state => state.preset),
  presets: createSelector(state => state.presets),
  config: createSelectorMemoized(state => state.adapter, state => state.visibleDate, state => state.preset, schedulerPreferenceSelectors.weekStartsOn, (adapter, visibleDate, preset, weekStartsOn) => {
    const config = EVENT_TIMELINE_PREMIUM_PRESET_CONFIGS[preset];
    if (!config) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI X Scheduler: No configuration registered for preset "${preset}". ` + `TimelineGridHeader cannot derive header rows or grid sizing without a config, so the timeline would render incorrectly. ` + `Use one of the built-in presets ("dayAndHour", "dayAndMonth", "dayAndWeek", "monthAndYear", "year").` : _formatErrorMessage(272, preset));
    }
    const {
      getStartDate,
      getEndDate,
      unitCount,
      getCssUnitCount,
      tickWidth,
      headers,
      timeResolution
    } = config;
    const start = getStartDate(adapter, visibleDate, weekStartsOn);
    const end = getEndDate(adapter, start, unitCount, weekStartsOn);
    return {
      tickCount: getCssUnitCount ? getCssUnitCount(adapter, start, end) : unitCount,
      start,
      end,
      tickWidth,
      headers,
      timeResolution
    };
  })
};